import React from 'react';
import './ErrorBanner.scss';
import { FiAlertCircle } from "react-icons/fi";

const ErrorBanner = ({ message }) => {
    return (
        <div className="error-banner">
            <FiAlertCircle className="error-icon" />
            <span className="error-text">{message}</span>
        </div>
    );
};

export default ErrorBanner;
